import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import React, { useState } from 'react';
import { IActivityQuery } from 'types/order/activities/IActivityQuery';
import { Calendar, IDropdownAnchor } from 'ui-toolkit';
import { SortItem } from './SortItem';
import { ClickToViewTableHeader } from './ClickToViewTableHeader';
import { getDateString } from '../../../ui-toolkit/utilities/getDateString';

export interface IActivityDateHeaderProps {
  occurredAtStart?: string;
  occurredAtEnd?: string;
  sortBy?: string;
  onFilterChange: (x: Partial<IActivityQuery>) => void;
}

export const ActivityDateHeader: React.FC<IActivityDateHeaderProps> = ({
  occurredAtEnd,
  occurredAtStart,
  sortBy,
  onFilterChange,
}) => {
  const [dateInput, setDateInput] = useState<string | string[] | undefined>(
    occurredAtStart && occurredAtEnd && [occurredAtStart, occurredAtEnd]
  );
  return (
    <ClickToViewTableHeader
      anchor={IDropdownAnchor.bottomLeft}
      text={'Activity Date'}
      filterText={
        (occurredAtEnd || occurredAtStart) &&
        `(${occurredAtStart && getDateString('M/dd/yyyy', occurredAtStart)} - ${
          occurredAtEnd && getDateString('M/dd/yyyy', occurredAtEnd)
        })`
      }
      icon={faCalendar}
      filterComponent={
        <Calendar
          inCard={false}
          inputDate={dateInput || null}
          onChange={(newDate) => {
            // do nothing if the change is to null
            if (!!newDate.value) {
              // if the first date is already selected
              if (dateInput && !!dateInput[0] && !dateInput[1])
                //using simple string sort
                setDateInput((prevState) => [prevState![0], newDate.value!].sort());
              else setDateInput([newDate.value!]);
            }
          }}
          selectionMode="range"
          showExtraMonths="previous"
          monthControlType={'control'}
          yearControlType={'control'}
        />
      }
      sortItem={
        <SortItem
          sortField={`occurredAt`}
          sortBy={sortBy}
          onChange={(sortBy) => onFilterChange({ sortBy, occurredAtStart, occurredAtEnd })}
        />
      }
      onFilterDone={() =>
        onFilterChange({ occurredAtEnd: dateInput && dateInput[1], occurredAtStart: dateInput && dateInput[0], sortBy })
      }
    />
  );
};
